export default __webpack_public_path__ + "alberta-summary.51a37c61d7cf77c62c41.svg";